var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3928 6.34203L3.26283 16.5502C3.07696 16.7376 2.97266 16.9907 2.97266 17.2546V21.0303H6.80085C7.06675 21.0303 7.3217 20.9244 7.50934 20.736L17.606 10.5996M13.3928 6.34203L15.5758 4.28225C16.7126 3.20963 18.4912 3.21818 19.6176 4.30169V4.30169C20.7875 5.42704 20.8195 7.2891 19.6888 8.4539L17.606 10.5996M13.3928 6.34203L17.606 10.5996",
    stroke: "#270072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0539fce2e28e392125af5e5e9ab7c8c6.svg";
export { ForwardRef as ReactComponent };